import { render, staticRenderFns } from "./wishlist-zwifloc.vue?vue&type=template&id=6b96b67c&scoped=true"
import script from "./wishlist-zwifloc.vue?vue&type=script&lang=js"
export * from "./wishlist-zwifloc.vue?vue&type=script&lang=js"
import style0 from "./wishlist-zwifloc.vue?vue&type=style&index=0&id=6b96b67c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b96b67c",
  null
  
)

export default component.exports